export const menuConfig = {
  esimcrew: [
    { id: "MENU001", name: "Home" },
    { id: "MENU007", name: "FAQ" },
    { id: "MENU005", name: "About Us" },
    { id: "MENU006", name: "Contact" },
  ],
  data2go: [
    { id: "MENU001", name: "Home" },
    { id: "MENU002", name: "Pricing" },
    { id: "MENU003", name: "Partners" },
    { id: "MENU004", name: "Affiliate" },
    { id: "MENU005", name: "About Us" },
    { id: "MENU006", name: "Contact" },
    { id: "MENU007", name: "FAQ" },
  ],
  esimlinks: [
    { id: "MENU001", name: "Home" },
    { id: "MENU002", name: "Pricing" },
    { id: "MENU004", name: "Affiliate" },
    { id: "MENU005", name: "About Us" },
    { id: "MENU006", name: "Contact" },
  ],
  gopamwe: [
    { id: "MENU001", name: "Home" },
    { id: "MENU002", name: "Pricing" },
    { id: "MENU004", name: "Affiliate" },
    { id: "MENU005", name: "About Us" },
    { id: "MENU006", name: "Contact" },
  ],
  esimple: [
    { id: "MENU001", name: "Home" },
    { id: "MENU002", name: "Pricing" },
    { id: "MENU004", name: "Affiliate" },
    { id: "MENU005", name: "About Us" },
    { id: "MENU006", name: "Contact" },
  ],
  ynertia:[
    { id: "MENU001", name: "Home" },
    { id: "MENU002", name: "Pricing" },
    { id: "MENU003", name: "Partners" },
    { id: "MENU004", name: "Affiliate" },
    { id: "MENU005", name: "About Us" },
    { id: "MENU006", name: "Contact" },
    { id: "MENU007", name: "FAQ" },
  ],
  awesim: [
    { id: "MENU001", name: "Home" },
    { id: "MENU008", name: "Global eSIMs" },
    { id: "MENU003", name: "Partners" },
    { id: "MENU005", name: "About Us" },
    { id: "MENU006", name: "Contact" },
  ],
};
export const languageConfig = {
  esimcrew: [
    { name: "English", code: "en" },
    { name: "Portuguese", code: "pt" },
    { name: "Spanish", code: "es" },
    { name: "Tagalog", code: "tl" }
  ],
  orzo: [
    { name: "English", code: "en" },
    { name: "Portuguese", code: "pt" },
    { name: "Spanish", code: "es" }
  ],
  pinoy: [
    { name: "English", code: "en" },
    { name: "Tagalog", code: "tl" }
  ],
  "data2go-iot": [
    { name: "English", code: "en" },
    { name: "Danish", code: "da" },
    { name: "Norwegian", code: "no" }
  ],
  esimlinks: [
    { name: "English", code: "en" },
    { name: "French", code: "fr" },
    { name: "German", code: "de" },
    { name: "Portuguese", code: "pt" },
    { name: "Spanish", code: "es" }
  ],
  gopamwe: [
    { name: "English", code: "en" },
    { name: "Portuguese", code: "pt" },
    { name: "Spanish", code: "es" }
  ],
  data2go: [
    { name: "English", code: "en" },
    { name: "Portuguese", code: "pt" },
    { name: "Spanish", code: "es" }
  ],
   elefone: [
    { name: "English", code: "en" }
  ],
  briant: [
    { name: "English", code: "en" }
  ],
  esimple: [
    { name: "English", code: "en" },
    { name: "Dutch", code: "nl" }
  ],
  ynertia: [
    { name: "English", code: "en" },
    { name: "Dutch", code: "nl" },
    { name: "Portuguese", code: "pt" },
    { name: "Spanish", code: "es" },
    { name: "Tagalog", code: "tl" }
  ],
  awesim: [
    { name: "English", code: "en" },
    { name: "Portuguese", code: "pt" },
    { name: "Spanish", code: "es" }
  ],
};
export const pageConfig = {
    All: "All",
    aboutUs: "About us",
    affiliate: "Affiliate",
    auth: "Authentication",
    branding: "Branding",
    config: "Configuration",
    contact: "Contact",
    domesticSim: "Domestic SIM",
    esim: "eSIM",
    family: "Family",
    faq: "FAQ",
    general: "General",
    header: "Menu",
    home: "Home",
    labels: "Labels",
    labelsIot: "Labels IOT",
    market: "Market",
    messageCatalog: "Message Catalogs",
    myAccount: "My account",
    nativeapp: "Mobile APP",
    partner: "Partner",
    payment: "Payment",
    plan: "Plans",
    profile: "Profile",
    redeemVoucher: "Redeem Voucher",
    support: "Support",
    validations: "Form validations",
    validationsIot: "Form validations IOT",
    voucher: "Voucher"
};
